/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Tracking_Bulkclosedeal_Modaldescription4Inputs */

const en_coinvestments_tracking_bulkclosedeal_modaldescription4 = /** @type {(inputs: Coinvestments_Tracking_Bulkclosedeal_Modaldescription4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to close ${i?.count} opportunities? This will prevent further edits.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to close {count} opportunities? This will prevent further edits." |
*
* @param {Coinvestments_Tracking_Bulkclosedeal_Modaldescription4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_bulkclosedeal_modaldescription4 = /** @type {((inputs: Coinvestments_Tracking_Bulkclosedeal_Modaldescription4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Bulkclosedeal_Modaldescription4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_bulkclosedeal_modaldescription4(inputs)
});
export { coinvestments_tracking_bulkclosedeal_modaldescription4 as "coInvestments_tracking_bulkCloseDeal_modalDescription" }